export const BiometricRegistrationModalKey = 'BiometricRegistrationModal'
export const AutoPayModalKey = 'AutoPayModal'
export const AutopayConfirmationModalKey = 'AutopayConfirmationModal'
export const AFFAutopayConfirmationModalKey = 'AFFAutopayConfirmationModal'
export const IdentityVerificationModalKey = 'IdentityVerificationModal'
export const IdentityVerificationTerminalErrorModalKey = 'IdentityVerificationTerminalErrorModal'
export const PayMonthlyTILAModalKey = 'PayMonthlyTILAModal'
export const PaymentOptionsErrorModalKey = 'PaymentOptionsErrorModal'
